import React from "react";
import { cn } from "../../shadcn/lib/utils";

const Pill = ({
  children,
  variant = "default",
  size = "default",
  className,
  ...props
}) => {
  const variantStyles = {
    default: "bg-[#f2f4f7] text-[#475467]",
    success: "bg-[#ecfdf3] text-[#067647]",
    warning: "bg-[#fffaeb] text-[#b54708]",
    error: "bg-[#fef3f2] text-[#b42318]",
    info: "bg-[#eff8ff] text-[#175cd3]",
    primary: "bg-[#f4ebff] text-[#6941c6]"
  };

  const sizeStyles = {
    sm: "text-xs px-2.5 py-1",
    default: "text-sm px-3 py-1.5",
    lg: "text-base px-4 py-2"
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold transition-colors",
        variantStyles[variant],
        sizeStyles[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default Pill;